module.exports = __webpack_public_path__ + "static/media/V64-label.e4585b5e.png";